import { scroller } from './smoothScroll';
import _ from 'underscore';
import { gsap, Power4, Power1, Expo } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default (els) => {
    Array.prototype.forEach.call(els, (el) => {
        //console.log(el);

        const brow = el.querySelector('.callout__brow > span');
        const heading = el.querySelector('.callout__heading > h2');
        const subtext = el.querySelector('.callout__subtext > p');
        const link = el.querySelector('.callout__link');


        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                end: 'bottom 80%',
                scrub: 1,
                markers: false,
            }
        });

        timeline.from(brow, {
            autoAlpha: 0,
            y: "-=30",
            duration: 1,
        });

        timeline.from(heading, {
            autoAlpha: 0,
            y: "+=30",
            duration: 1,
        });

        timeline.from(subtext, {
            autoAlpha: 0,
            y: "+=30",
            duration: 1,
        });

        timeline.from(link, {
            autoAlpha: 0,
            y: "+=30",
            duration: 1,
        });

    });
};